// composeApp/src/commonMain/kotlin/dk/smark/demo/auth/CredentialsStorage.kt
package dk.smark.demo.auth

data class SavedCredentials(val email: String, val password: String)

interface CredentialsStorage {
    fun save(email: String, password: String)
    fun load(): SavedCredentials?
    fun clear()
}

expect fun createCredentialsStorage(): CredentialsStorage